import app from "@/app";
import PUserEdit from "./oweb/PUserEdit";
import PUserLogin from "./oweb/PUserLogin";
import PUserLogout from "./oweb/PUserLogout";
import PUserPassEdit from "./oweb/PUserPassEdit";
import PUserPicEdit from "./oweb/PUserPicEdit";
import PUserAccountRecovery from "./oweb/PUserAccountRecovery";
import PUserSignup from "./oweb/PUserSignup";

import PAppUpdate from "./oweb/PAppUpdate";
import PHome from "./PHome";
import PAccount from './PAccount';
import PCompany from './PCompany';
import PSector from './PSector';
import PSurvey from './PSurvey';

app.pager
	.registerPage(new PHome)
	.registerPage(new PAccount)
	.registerPage(new PCompany)
	.registerPage(new PSector)
	.registerPage(new PSurvey)

	// oweb
	.registerPage(new PUserLogin)
	.registerPage(new PUserSignup)
	.registerPage(new PUserLogout)
	.registerPage(new PUserAccountRecovery)
	.registerPage(new PUserEdit)
	.registerPage(new PUserPassEdit)
	.registerPage(new PUserPicEdit)
	.registerPage(new PAppUpdate);
